import { Component } from '@angular/core';
import { NavigationComponent } from './navigation/navigation.component';
import { TopBarComponent } from './top-bar/top-bar.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  imports: [TopBarComponent, NavigationComponent],
})
export class HeaderComponent {}
